import axios from "axios";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
const appauth_key = "barlays@2029";
let APL_LINK = "http://192.168.1.21:8000/";
//APL_LINK = "http://127.0.0.1:7998/";
APL_LINK = "https://backend.rapidcarleasing.com/";
// APL_LINK = "https://backenddemo.rapidcarleasing.com/";
let Website_URL = "https://www.rapidcarleasing.com/";
let local_server_link_react = APL_LINK + "api/admin_link/";
let feedback_online_link = "https://www.wowreviews.co/Adminmaster/";

// API functions

const login_to_superadmin = local_server_link_react + "login_to_superadmin";
const forgot_password = local_server_link_react + "forgot_password";
const check_resetlink_vaild = local_server_link_react + "check_resetlink_vaild";
const change_password_by_forgot =
  local_server_link_react + "change_password_by_forgot";
const save_update_staff = local_server_link_react + "save_update_staff";
const get_all_staff = local_server_link_react + "get_all_staff";
const action_update_staff = local_server_link_react + "action_update_staff";
const save_update_designtion =
  local_server_link_react + "save_update_designtion";
const get_all_contact_data = local_server_link_react + "get_all_contact_data";
const update_guest_vip_status =
  local_server_link_react + "update_guest_vip_status";
const view_calender_reservation =
  local_server_link_react + "view_calender_reservation";
const view_reservation_history =
  local_server_link_react + "view_reservation_history";
const update_profile_staff = local_server_link_react + "update_profile_staff";

const save_update_faq = local_server_link_react + "save_update_faq";
const get_all_faq = local_server_link_react + "get_all_faq";
const save_update_knowledgebase =
  local_server_link_react + "save_update_knowledgebase";
const get_all_knowledgebase = local_server_link_react + "get_all_knowledgebase";

const get_all_diningarea = local_server_link_react + "get_all_diningarea";
const delete_diningarea = local_server_link_react + "delete_diningarea";
const update_primary_diningarea =
  local_server_link_react + "update_primary_diningarea";
const update_diningarea_sequence =
  local_server_link_react + "update_diningarea_sequence";
const get_all_table_position = local_server_link_react + "get_all_tablesetup";
const get_all_table_position2 = local_server_link_react + "get_all_tablesetup2";
const sava_update_table_position = local_server_link_react + "save_tablesetup";
const delete_tablesetup = local_server_link_react + "delete_tablesetup";

const save_new_resturant = local_server_link_react + "save_new_resturant";
const get_all_new_resturant = local_server_link_react + "get_all_new_resturant";
const action_update_resturant =
  local_server_link_react + "action_update_resturant";

const view_special_timing = local_server_link_react + "view_special_timing";
const view_week_all_timing = local_server_link_react + "view_week_all_timing";
const save_update_special_timing =
  local_server_link_react + "save_update_special_timing";
const save_update_week_timing =
  local_server_link_react + "save_update_week_timing";
const allot_table_to_reservation =
  local_server_link_react + "allot_table_to_reservation";
const get_all_StaffRights = local_server_link_react + "get_all_StaffRights";
const save_update_StaffRights =
  local_server_link_react + "save_update_StaffRights";
const save_update_general_Settings =
  local_server_link_react + "save_update_general_Settings";
const get_all_ReservationSetting =
  local_server_link_react + "get_all_ReservationSetting";
const get_all_reservation_date_notification =
  local_server_link_react + "get_all_reservation_date_notification";
const get_all_reservation_date =
  local_server_link_react + "get_all_reservation_date";
const update_action_reservation =
  local_server_link_react + "update_action_reservation";
const table_release_from_reservation =
  local_server_link_react + "table_release_from_reservation";
const get_all_timing_date_wise =
  local_server_link_react + "get_all_timing_date_wise";
const create_table_reservation_staff =
  local_server_link_react + "create_table_reservation_staff";
const get_all_floor_data = local_server_link_react + "get_all_floor_data";
const action_update_staff_right =
  local_server_link_react + "action_update_staff_right";
const get_all_designation = local_server_link_react + "get_all_designation";
const update_calender_seat_status =
  local_server_link_react + "update_calender_seat_status";
const check_no_show_review = local_server_link_react + "check_no_show_review";
const get_all_analyticsReservation =
  local_server_link_react + "admin_dashboard";
const get_analyticsReservationHourly =
  local_server_link_react + "get_analyticsReservationHourly";
const get_reservation_by_mobile_no =
  local_server_link_react + "get_reservation_by_mobile_no";
const get_all_notification = local_server_link_react + "get_all_notification";
const update_notification_status =
  local_server_link_react + "update_notification_status";

const feedback_dashboard_view =
  feedback_online_link + "feedback_dashboard_view";
const bad_bus_search_api = feedback_online_link + "bad_bus_search_api";

const get_all_searchmaster = local_server_link_react + "get_all_searchmaster";
const save_update_searchmaster =
  local_server_link_react + "save_update_searchmaster";
const insert_note_from_feedback =
  local_server_link_react + "insert_note_from_feedback";
const get_all_notes_by_id = local_server_link_react + "get_all_notes_by_id";
const get_all_ReportsReservation =
  local_server_link_react + "get_all_ReportsReservation";
const get_all_ReportsSales = local_server_link_react + "get_all_ReportsSales";
const get_all_guestReport = local_server_link_react + "get_all_guestReport";
const get_all_tablesetup2_for_edit =
  local_server_link_react + "get_all_tablesetup2_for_edit";

/**website links */
const payment_data_api = local_server_link_react + "payment_data_api";
const get_all_subscribe = local_server_link_react + "get_all_subscribe";
const save_update_blog = local_server_link_react + "save_update_blog";
const get_all_blogs = local_server_link_react + "get_all_blogs";
const save_update_seo = local_server_link_react + "save_update_seo";
const get_all_seo = local_server_link_react + "get_all_seo";
const save_update_imagelink = local_server_link_react + "save_update_imagelink";
const get_all_imagelink = local_server_link_react + "get_all_imagelink";
const save_update_team = local_server_link_react + "save_update_team";
const save_update_blogfaq = local_server_link_react + "save_update_blogfaq";
const get_all_blogfaq = local_server_link_react + "get_all_blogfaq";
const get_all_team = local_server_link_react + "get_all_team";
const save_update_EventResturant =
  local_server_link_react + "save_update_EventResturant";
const get_all_EventResturant =
  local_server_link_react + "get_all_EventResturant";
const get_all_WebsiteCaps = local_server_link_react + "get_all_WebsiteCaps";
const save_update_WebsiteCaps =
  local_server_link_react + "save_update_WebsiteCaps";
const delete_website_master_data =
  local_server_link_react + "delete_website_master_data";
const get_all_Vacancy = local_server_link_react + "get_all_Vacancy";
const save_update_Vacancy = local_server_link_react + "save_update_Vacancy";
const update_data_career = local_server_link_react + "update_data_career";
const get_all_WebsiteManagement =
  local_server_link_react + "get_all_WebsiteManagement";
const save_update_WebsiteManagement =
  local_server_link_react + "save_update_WebsiteManagement";

// new api created by shivam

const get_update_terms_privacy =
  local_server_link_react + "get_update_terms_privacy";
const save_blog_keyword = local_server_link_react + "save_blog_keyword";
const submit_update_drop_data =
  local_server_link_react + "submit_update_drop_data";
const get_all_blog_keyword = local_server_link_react + "get_all_blog_keyword";
const get_all_testimonial = local_server_link_react + "get_all_testimonial";
const save_update_testimonial =
  local_server_link_react + "save_update_testimonial";
const get_all_carmodel = local_server_link_react + "get_all_carmodel";
const save_update_carmodel = local_server_link_react + "save_update_carmodel";
const save_car_destails = local_server_link_react + "save_car_destails";
const cardetails_api_data = local_server_link_react + "cardetails_api_data";
const get_all_car_data = local_server_link_react + "get_all_car_data";
const status_update_change = local_server_link_react + "status_update_change";
const delete_multi_image = local_server_link_react + "delete_multi_image";
const get_all_users = local_server_link_react + "get_all_users";
const get_all_car_faq = local_server_link_react + "get_all_car_faq";
const save_update_car_faq = local_server_link_react + "save_update_car_faq";
const save_service_save_payment =
  local_server_link_react + "save_service_save_payment";

const get_all_booking_data = local_server_link_react + "get_all_booking_data";
const maintainance_data_dropdown =
  local_server_link_react + "maintainance_data_dropdown";
const add_maintainance_data = local_server_link_react + "add_maintainance_data";
const maintainance_status = local_server_link_react + "maintainance_status";
const action_update_agent = local_server_link_react + "action_update_agent";
const get_all_agent = local_server_link_react + "get_all_agent";
const save_update_agent = local_server_link_react + "save_update_agent";
const maintainance_data_for_id =
  local_server_link_react + "maintainance_data_for_id";
const submit_accept_reject_booking =
  local_server_link_react + "submit_accept_reject_booking";
const submit_update_insurance_data =
  local_server_link_react + "submit_update_insurance_data";
const submit_update_pickup_data =
  local_server_link_react + "submit_update_pickup_data";
const drop_car_api = local_server_link_react + "drop_car_api";
const get_car_transaction_details =
  local_server_link_react + "get_car_transaction_details";
const get_car_walkin_booking =
  local_server_link_react + "get_car_walkin_booking";
const create_walkIn_booking = local_server_link_react + "create_walkIn_booking";
const filter_booking_data = local_server_link_react + "filter_booking_data";
const get_repairing_data_new =
  local_server_link_react + "get_repairing_data_new";
const get_oilcheck_data_new = local_server_link_react + "get_oilcheck_data_new";
const maintainance_car_data = local_server_link_react + "maintainance_car_data";
const get_maintainance_data = local_server_link_react + "get_maintainance_data";
const repairing_car_data = local_server_link_react + "repairing_car_data";
const oilcheck_car_data = local_server_link_react + "oilcheck_car_data";
const get_needed_repairing_data =
  local_server_link_react + "get_needed_repairing_data";
const get_needed_oilcheck_data =
  local_server_link_react + "get_needed_oilcheck_data";
const get_booking_data = local_server_link_react + "get_booking_data";
const create_walkIn_booking_edit =
  local_server_link_react + "create_walkIn_booking_edit";
const get_cars_data = local_server_link_react + "get_cars_data";
const get_maintainance_data_new =
  local_server_link_react + "get_maintainance_data_new";
const get_needed_maintainance_data =
  local_server_link_react + "get_needed_maintainance_data";
const get_pickup_data_admin = local_server_link_react + "get_pickup_data_admin";
const save_image_pdf_dashboard =
  local_server_link_react + "save_image_pdf_dashboard";
const upload_image_to_folder =
  local_server_link_react + "upload_image_to_folder";
const multicar_upload_image = local_server_link_react + "multicar_upload_image";
const add_payment_mutiple_drop_final =
  local_server_link_react + "add_payment_mutiple_drop_final";
const get_booking_details = local_server_link_react + "get_booking_details";
const get_user_data_for_edit =
  local_server_link_react + "get_user_data_for_edit";
const save_user_data_for_edit =
  local_server_link_react + "save_user_data_for_edit";
const customer_view_deatils = local_server_link_react + "customer_view_deatils";
const Add_car_feature = local_server_link_react + "Add_car_feature";
const get_car_feature = local_server_link_react + "get_car_feature";
const delete_car_feature = local_server_link_react + "delete_car_feature";
const car_repo_api = local_server_link_react + "car_repo_api";
const get_repo_data = local_server_link_react + "get_repo_data";
const get_car_ipass_data = local_server_link_react + "get_car_ipass_data";
const change_payment_status = local_server_link_react + "change_payment_status";
const delete_car_ipass_data = local_server_link_react + "delete_car_ipass_data";
const save_car_ipass_data = local_server_link_react + "save_car_ipass_data";
const assign_ipass_car = local_server_link_react + "assign_ipass_car";
const unassign_ipass_car = local_server_link_react + "unassign_ipass_car";
const reactivate_ipass_car = local_server_link_react + "reactivate_ipass_car";
const get_all_transaction_data =
  local_server_link_react + "get_all_transaction_data";
const get_all_payment_reallocation =
  local_server_link_react + "get_all_payment_reallocation";
const get_drives_data_payment =
  local_server_link_react + "get_drives_data_payment";
const get_booking_data_by_driver =
  local_server_link_react + "get_booking_data_by_driver";
const save_discount_amount_payment =
  local_server_link_react + "save_discount_amount_payment";
const save_service_charge_amount_payment =
  local_server_link_react + "save_service_charge_amount_payment";
const payment_analytics = local_server_link_react + "payment_analytics";
const get_weekly_report_all_driver =
  local_server_link_react + "get_weekly_report_all_driver";
const driver_all_booking_report =
  local_server_link_react + "driver_all_booking_report";
const update_payment = local_server_link_react + "update_payment";
const user_ledger_data_by_id =
  local_server_link_react + "user_ledger_data_by_id";
const get_driver_lager_data =
  local_server_link_react + "get_driver_lager_data ";
const get_driver_day_wise_data =
  local_server_link_react + "get_driver_day_wise_data ";
const payment_refund_api = local_server_link_react + "payment_refund_api ";
const payment_reallocation = local_server_link_react + "payment_reallocation ";
const get_discount_ledger_data =
  local_server_link_react + "get_discount_ledger_data ";
const change_ipass_status = local_server_link_react + "change_ipass_status ";
const upload_ipass_excel_data =
  local_server_link_react + "upload_ipass_excel_data ";
const generate_links_and_update_ledger =
  local_server_link_react + "generate_links_and_update_ledger ";
const change_payment_cycle = local_server_link_react + "change_payment_cycle";
const get_booking_ipass_data =
  local_server_link_react + "get_booking_ipass_data";
const ipass_switch = local_server_link_react + "ipass_switch ";
const get_switch_car_booking =
  local_server_link_react + "get_switch_car_booking ";
const upload_mvr_pdf = local_server_link_react + "upload_mvr_pdf ";
const get_all_cars_without_booking =
  local_server_link_react + "get_all_cars_without_booking ";
const update_booking_car_in_review =
  local_server_link_react + "update_booking_car_in_review ";
const cancel_booking_admin = local_server_link_react + "cancel_booking_admin ";
const get_payment_booking_report =
  local_server_link_react + "get_payment_booking_report ";
const save_contact_admin = local_server_link_react + "save_contact_admin";
const save_contact_log = local_server_link_react + "save_contact_log";
const update_show_hide_status =
  local_server_link_react + "update_show_hide_status";
const upload_driving_licence_image =
  local_server_link_react + "upload_driving_licence_image";
const newstatus_update_change =
  local_server_link_react + "newstatus_update_change";
const get_workshop_enquiry_report =
  local_server_link_react + "get_workshop_enquiry_report";
const get_car_report = local_server_link_react + "get_car_report";
const get_car_maintanance_report =
  local_server_link_react + "get_car_maintanance_report";
const get_ipass_toll_unused_data =
  local_server_link_react + "get_ipass_toll_unused_data";
const get_toll_details_data = local_server_link_react + "get_toll_details_data";
const update_manual_toll_status =
  local_server_link_react + "update_manual_toll_status";
const update_last_maintenance_notes =
  local_server_link_react + "update_last_maintenance_notes";
const save_user_data_for_booking =
  local_server_link_react + "save_user_data_for_booking";
const upload_mvr_image = local_server_link_react + "upload_mvr_image";

/**website links */
// Retrieving data

const retrievedAdminId = retrieveData("admin_id");

const server_post_data = async (url_for, form_data) => {
  // const headers = {
  //   "Content-Type": "application/json",
  // };

  if (form_data === null) {
    form_data = new FormData();
  }
  form_data.append("admin_id", retrievedAdminId);
  form_data.append("appauth_key", appauth_key);
  if (form_data.get("data_call") !== null) {
    form_data.append("call_id", retrievedAdminId);
  }
  return axios.post(url_for, form_data);
};

export {
  action_update_agent,
  action_update_resturant,
  action_update_staff,
  action_update_staff_right,
  add_maintainance_data,
  allot_table_to_reservation,
  APL_LINK,
  appauth_key,
  bad_bus_search_api,
  cardetails_api_data,
  change_password_by_forgot,
  check_no_show_review,
  check_resetlink_vaild,
  create_table_reservation_staff,
  create_walkIn_booking,
  delete_diningarea,
  delete_multi_image,
  delete_tablesetup,
  delete_website_master_data,
  drop_car_api,
  feedback_dashboard_view,
  filter_booking_data,
  forgot_password,
  get_all_agent,
  get_all_analyticsReservation,
  get_all_blog_keyword,
  get_all_blogs,
  get_all_booking_data,
  get_all_car_data,
  get_all_car_faq,
  get_all_carmodel,
  get_all_contact_data,
  get_all_designation,
  get_all_diningarea,
  get_all_EventResturant,
  get_all_faq,
  get_all_floor_data,
  get_all_guestReport,
  get_all_imagelink,
  get_all_knowledgebase,
  get_all_new_resturant,
  get_all_notes_by_id,
  get_all_notification,
  get_all_ReportsReservation,
  get_all_ReportsSales,
  get_all_reservation_date,
  get_all_reservation_date_notification,
  get_all_ReservationSetting,
  get_all_searchmaster,
  get_all_seo,
  get_all_staff,
  get_all_StaffRights,
  get_all_subscribe,
  get_all_table_position,
  get_all_table_position2,
  get_all_tablesetup2_for_edit,
  get_all_team,
  get_all_testimonial,
  get_all_timing_date_wise,
  get_all_users,
  get_all_Vacancy,
  get_all_WebsiteCaps,
  get_all_WebsiteManagement,
  get_analyticsReservationHourly,
  get_booking_data,
  //website Links
  create_walkIn_booking_edit,
  get_car_transaction_details,
  get_car_walkin_booking,
  get_maintainance_data,
  get_reservation_by_mobile_no,
  // new api created by shivam
  get_update_terms_privacy,
  insert_note_from_feedback,
  login_to_superadmin,
  maintainance_data_dropdown,
  maintainance_data_for_id,
  maintainance_status,
  sava_update_table_position,
  save_blog_keyword,
  save_car_destails,
  save_new_resturant,
  save_update_agent,
  //website Links
  save_update_blog,
  save_update_car_faq,
  save_update_carmodel,
  save_update_designtion,
  save_update_EventResturant,
  save_update_faq,
  save_update_general_Settings,
  save_update_imagelink,
  save_update_knowledgebase,
  save_update_searchmaster,
  save_update_seo,
  save_update_special_timing,
  save_update_staff,
  save_update_StaffRights,
  save_update_team,
  save_update_blogfaq,
  get_all_blogfaq,
  save_update_testimonial,
  save_update_Vacancy,
  save_update_WebsiteCaps,
  save_update_WebsiteManagement,
  save_update_week_timing,
  server_post_data,
  status_update_change,
  submit_accept_reject_booking,
  submit_update_insurance_data,
  submit_update_pickup_data,
  table_release_from_reservation,
  update_action_reservation,
  update_calender_seat_status,
  update_data_career,
  update_diningarea_sequence,
  update_guest_vip_status,
  update_notification_status,
  update_primary_diningarea,
  update_profile_staff,
  view_calender_reservation,
  view_reservation_history,
  view_special_timing,
  view_week_all_timing,
  Website_URL,
  get_cars_data,
  get_needed_maintainance_data,
  maintainance_car_data,
  payment_data_api,
  get_maintainance_data_new,
  get_pickup_data_admin,
  save_image_pdf_dashboard,
  upload_image_to_folder,
  submit_update_drop_data,
  multicar_upload_image,
  add_payment_mutiple_drop_final,
  get_booking_details,
  get_user_data_for_edit,
  save_user_data_for_edit,
  customer_view_deatils,
  Add_car_feature,
  get_car_feature,
  delete_car_feature,
  car_repo_api,
  get_repo_data,
  get_car_ipass_data,
  change_payment_status,
  delete_car_ipass_data,
  save_car_ipass_data,
  assign_ipass_car,
  unassign_ipass_car,
  reactivate_ipass_car,
  save_service_save_payment,
  get_all_transaction_data,
  get_drives_data_payment,
  get_booking_data_by_driver,
  save_discount_amount_payment,
  save_service_charge_amount_payment,
  payment_analytics,
  get_weekly_report_all_driver,
  driver_all_booking_report,
  update_payment,
  user_ledger_data_by_id,
  get_driver_lager_data,
  get_driver_day_wise_data,
  payment_refund_api,
  get_discount_ledger_data,
  change_ipass_status,
  upload_ipass_excel_data,
  change_payment_cycle,
  get_booking_ipass_data,
  ipass_switch,
  get_switch_car_booking,
  upload_mvr_pdf,
  generate_links_and_update_ledger,
  update_booking_car_in_review,
  get_all_cars_without_booking,
  cancel_booking_admin,
  payment_reallocation,
  get_all_payment_reallocation,
  get_payment_booking_report,
  save_contact_admin,
  save_contact_log,
  get_workshop_enquiry_report,
  upload_driving_licence_image,
  newstatus_update_change,
  update_show_hide_status,
  repairing_car_data,
  oilcheck_car_data,
  get_repairing_data_new,
  get_oilcheck_data_new,
  get_needed_repairing_data,
  get_needed_oilcheck_data,
  get_car_maintanance_report,
  get_car_report,
  get_ipass_toll_unused_data,
  get_toll_details_data,
  update_manual_toll_status,
  update_last_maintenance_notes,
  save_user_data_for_booking,
  upload_mvr_image
};
